/** Normalize contact page email/phone lists for the merchant editor and storefront.

Keep empty extra rows when the merchant added fields (array length > 1 or
explicit empties). Collapse to the legacy single field only when the list
key is missing or empty.
*/
export function contactList(data, plural, single) {
  const raw = data?.[plural];
  if (Array.isArray(raw) && raw.length > 0) {
    return raw.map((x) => String(x ?? ""));
  }
  const one = String(data?.[single] || "");
  return one ? [one] : [""];
}
